import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { TemplateDetailSchema } from "./useActionPlanTemplate";

export type TemplateLifecycleOperation = "archive" | "unarchive" | "duplicate";

export const useTemplateLifecycle = (id: string) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (operation: TemplateLifecycleOperation) => {
            const response = await loggedInApiCall.post(`/api/action-plan-templates/${id}/${operation}`);
            return TemplateDetailSchema.parse(response.data);
        },
        onSuccess: (template) => {
            queryClient.setQueryData(["actionPlanTemplate", template.id], template);
            void queryClient.invalidateQueries(["actionPlanTemplates"]);
        },
    });
};
